














































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";
import { getBirthday, getTimeAgo } from "@/services/dateTime/date-time-fofmat";

import MailButtons from "@/components/buttons/tv/mail-buttons.vue";
import StandartTable from "@/components/tables/standart-table.vue";

@Component({ components: { MailButtons, StandartTable } })
export default class TvTable extends Vue {
  @Prop({ type: Array, default: [] }) users!: IUser[];
  @Prop({ type: String, default: "tv" }) deviceType!: string;

  get colspan(): number {
    return this.deviceType == "tablet" ? 9 : 13;
  }

  get labelPrefix(): string {
    return this.deviceType == "tablet"
      ? "Administration.tablet"
      : "Administration.tv";
  }

  userIp(user: IUser): string {
    if (user.property && user.property.ip) return user.property.ip;
    if (user.ip) {
      if (Array.isArray(user.ip)) return user.ip.join(", ");
      return user.ip;
    }
    return "-";
  }

  getBirthday(date: string | Date): string {
    return getBirthday(date);
  }

  getDateTime(date: string | Date): string {
    return getTimeAgo(date);
  }

  statusClass(status: string): string {
    switch (status) {
      case "Online":
        return "online";
      case "Warm":
        return "warm";
      case "Offline":
        return "offline";
      default:
        return "unknown";
    }
  }
}
